import React, { useCallback, useState, useEffect, Fragment, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
// Actions
import {
  searchSubUser,
  getSubUser,
  getCurrentSubUser,
  resendInvite,
  clearRedux,
} from "Redux/actions";
//Components
import TableSubUser from './components/table';
import CreditEditSubUser from './components/creditEditSubUser';
import DeleteSubUser from './components/deleteSubUser';
import ImportSubUserModal from './components/importSubUserModal';
import { NotificationManager } from 'Components/Notifications';
import { usePagination } from 'Components/uiControls/Table/hooks';
import ResetEmail from './components/resetEmail';
import ResetPassword from './components/resetPassword';

const SubUser = () => {
  const { messages } = useIntl();
  const dispatch = useDispatch();
  // Ref
  const tableRef = useRef();
  // State local
  const [typeAction, setTypeAction] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [onShowModal, setOnShowModal] = useState(false);
  const [showResetEmail, setShowResetEmail] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [onShowModalDelete, setOnShowModalDelete] = useState(false);
  const [selectedSubUser, setSelectedSubUser] = useState(null);
  const [subUserInfo, setSubUserInfo] = useState(null);

  // State manager
  const {
    loading,
    allfilters,
    loadedRecord,
    loadedResetCognito,
    error: errorSubUser,
    resultPasswordReset,
    resultReSendInvite
  } = useSelector(
    (state) => state.subUserRedux
  );
  const pagination = usePagination(tableRef, searchSubUser, allfilters);

  // State manager
  const { user } = useSelector(
    (state) => state.securityRedux
  );

  const { subUserSelected, loadingSubUser } = useSelector(state => state.subUserRedux);
  const openImportModal = useSelector((state) => state.subUsersImportReducer.openImport);

  const getData = useCallback(() => {
    dispatch(searchSubUser(allfilters));
    tableRef?.current?.setPage(1);
    tableRef?.current?.setSelectedItems([]);
    pagination.setSelectedItems([]);
  })


  const onChangeResetPassword = (status) => {
    setShowResetPassword(status)
  }
  //type of action
  const onActions = (type, item) => {
    const actions = {
      [messages['edit']]: "edit",
      [messages['delete']]: "delete",
      [messages['subUser_resetEmail']]: "resetEmail",
      [messages['subUser_resetPassword']]: "resetPassword",
      [messages['subUser_resendInvite']]: "resendInvite",
      [messages['create']]: "create"
    }
    type = actions[type] || ""
    const typeLowerCase = type && type.toLowerCase();
    switch (typeLowerCase) {
      case 'create':
        setSelectedSubUser(null);
        dispatch(clearRedux("SUB_USER", { subUserSelected: null }));
        setOnShowModal(true);
        break;
      case 'edit':
        dispatch(getSubUser({ id: item.id }))
        setOnShowModal(true);
        break;
      case 'delete':
        setSelectedSubUser(item ? [item] : selectedItems);
        setOnShowModalDelete(!onShowModalDelete);
        break;
      case 'resetemail':
        setSelectedSubUser(item ? [item] : selectedItems);
        setShowResetEmail(true);
        break;
      case 'resendinvite':
        dispatch(resendInvite({ id: item.id }))
        break;
      case 'resetpassword':
        setSelectedSubUser(item ? [item] : selectedItems);
        onChangeResetPassword(true);
        break;
      default:
        setSelectedSubUser(null);
        setOnShowModal(false);
        setShowResetEmail(false);
        onChangeResetPassword(false);
        dispatch(clearRedux("SUB_USER", { subUserSelected: null }));
        dispatch(clearRedux("USER_TYPE", { getUserType: null }));
        break;
    }
    setTypeAction(typeLowerCase);
  }

  useEffect(() => {
    if (loadedRecord) {
      NotificationManager.success(
        messages[`subUser_${typeAction}Message`],
        messages['success'],
        4500,
        null,
        null,
        'Success',
      );

      getData();
      dispatch(clearRedux("SUB_USER", {
        subUserSelected: null,
        loadedRecord: false,
      }));

      dispatch(clearRedux("USER_TYPE", {
        getUserType: null,
        loadedRecord: false
      }));

      if (typeAction === "delete") {
        dispatch(clearRedux("ACCOUNT_API_KEYS", { updateSubUsers: true }));
      }

      typeAction !== "delete" ?
        setOnShowModal(!onShowModal) :
        setOnShowModalDelete(!onShowModalDelete);

      setSelectedSubUser(null);
      setSelectedItems([]);
      setTypeAction("");
    }

  }, [loadedRecord]);

  useEffect(() => {
    if (loadedResetCognito) {
      NotificationManager.success(
        messages[`subUser_successResetCognito`],
        messages['success'],
        4000,
        null,
        null,
        'Success',
      );

      getData();
      dispatch(clearRedux("SUB_USER", {
        subUserSelected: null,
        loadedResetCognito: false
      }));

      setOnShowModal(false);
      setShowResetEmail(false);
      setSelectedSubUser(null);
      setTypeAction("");
    }
  }, [loadedResetCognito])

  useEffect(() => {
    if (resultPasswordReset || resultReSendInvite) {
      NotificationManager.success(
        resultPasswordReset ? messages[`subUser_successPasswordReset`] : "Invitation sent",
        messages['success'],
        4500,
        null,
        null,
        'Success',
      );

      getData();
      dispatch(clearRedux("SUB_USER", {
        subUserSelected: null,
        resultPasswordReset: false,
        resultReSendInvite: false
      }));


      onChangeResetPassword(false);
      setOnShowModal(false);
      setSelectedSubUser(null);
      setTypeAction("");
    }
  }, [resultPasswordReset, resultReSendInvite])



  useEffect(() => {
    if (errorSubUser) {
      dispatch(clearRedux("SUB_USER", { error: null }));
    }
  }, [errorSubUser]);

  useEffect(() => {

    if (user?.isSubUser && user?.subUserId) {
      //get information for all tags
      dispatch(getSubUser({ id: user.subUserId }))
      dispatch(getCurrentSubUser({ id: user.subUserId }))
    }

    return () => {
      dispatch(clearRedux("SUB_USER"));
      dispatch(clearRedux("USER_TYPE"));
    }
  }, []);

  useEffect(() => {
    if (user?.isSubUser && !loadingSubUser && subUserSelected && !subUserInfo) {
      setSubUserInfo(subUserSelected)
      setSelectedSubUser(null);
      dispatch(clearRedux("SUB_USER", { subUserSelected: null }));
      dispatch(clearRedux("USER_TYPE", { getUserType: null }));
    }
  }, [subUserSelected])

  return (
    <Fragment>
      <TableSubUser
        tableRef={tableRef}
        dateFormat={user.dateformat}
        onActions={onActions}
        setSelectedItems={(items) => setSelectedItems(items)}
        pagination={pagination}
        loadingSubUser={loadingSubUser}
      />
      {onShowModal &&
        <CreditEditSubUser
          onShow={onShowModal}
          subUserInfo={subUserInfo}
          onClose={() => onActions()}
        />
      }
      <ResetEmail
        showResetEmail={showResetEmail}
        onClose={() => onActions()}
        subUserInfo={selectedSubUser}
      />
      <DeleteSubUser
        loading={loading}
        subUsers={selectedSubUser}
        onShow={onShowModalDelete}
        pagination={pagination}
        onClose={() => setOnShowModalDelete(!onShowModalDelete)}
      />
      <ResetPassword
        showResetEmail={showResetPassword}
        onChangeResetPassword={onChangeResetPassword}
        subUserInfo={selectedSubUser}
      />
      {openImportModal && <ImportSubUserModal />}

    </Fragment>
  );
}

export default SubUser;